import { cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';
import Progress from 'components/shared/Progress/Progress';

import { WIZARD_PROGRESS } from '../../../lib/constants';

const StageHeader = ({ icon, title, steps, open = false, expandAll = false, onExpandAll }) => {
  const completedSubsteps = steps?.reduce((acc, step) => {
    if (step.status === WIZARD_PROGRESS.CONFIRMED) {
      return acc + (step.substeps?.length ?? 0);
    }

    const completedCount =
      step.substeps?.filter(
        (substep) =>
          substep.status === WIZARD_PROGRESS.COMPLETED ||
          substep.status === WIZARD_PROGRESS.CONFIRMED
      ).length ?? 0;

    return acc + completedCount;
  }, 0);
  const totalSubsteps = steps?.reduce((acc, step) => acc + (step.substeps?.length ?? 0), 0) ?? 0;
  const progressPercentage =
    totalSubsteps > 0 ? Math.round((completedSubsteps / totalSubsteps) * 100) : 0;

  return (
    <div className="flex w-full justify-between">
      <div className="flex items-center gap-1">
        <Icon
          icon="chevron-down-filled"
          size={20}
          className={cn('transition-transform duration-200', open ? 'rotate-180' : '')}
        />
        <Icon icon={icon ?? 'responsibility-1'} size={30} />
        <p className="ml-2 font-500 text-neutral-600">{title}</p>
      </div>
      <div className="flex items-center">
        <div className="mr-4 flex items-center gap-1 text-xs text-neutral-800">
          Completed: <b>{completedSubsteps ?? 0}</b> out of{' '}
          <b>{steps?.reduce((acc, step) => acc + (step.substeps?.length ?? 0), 0) ?? 0}</b>
          <span className="text-sm font-500 leading-3 text-neutral-400">/</span>
          <Progress percentage={progressPercentage} />
        </div>
        <Button
          icon="maximize-linear"
          variant="link"
          iconShade={700}
          size="small"
          shade={700}
          color="neutral"
          className="px-2"
          text={expandAll ? 'Collapse all' : 'Expand all'}
          onClick={(e) => {
            // Only stop propagation when the stage is already in the desired state:
            // expanding an open stage (keep open) or collapsing a closed stage (keep closed)
            if (open !== expandAll) e.stopPropagation();
            onExpandAll?.(!expandAll);
          }}
        />
      </div>
    </div>
  );
};

export default StageHeader;
